import { get } from '../shared/utils/FetchV2.util';
import { CatalogResult } from '../shared/catalog/types';

/**
 * Fetches the WHOLE priced product catalog from heru-sales-transaction-engine
 * in one call:
 *   GET /api/v1/heru-sales-transaction-engine/pricing/catalog?section=all
 *
 * Returns every section's products (each carries its own `type`), so the client
 * fetches once and filters per surface (see `useCatalog`). `final` is the real
 * Talon price for the logged-in user — the backend resolves the user from the
 * Bearer JWT claim (FetchV2 always attaches the token), so we don't send a
 * user_id. Routed via the `salesTransactionEngine` SERVICE_CONFIG.
 */
export const getPricingCatalog = async (): Promise<CatalogResult> =>
	get<CatalogResult>({
		service: 'salesTransactionEngine',
		endpoint: `/pricing/catalog?section=all`,
	});

export interface ProductLookupItem {
	product_version_id: number;
	name: string;
	periodicity?: 'monthly' | 'annual';
}

/**
 * Lightweight product_version_id → name/periodicity for EVERY product. Used to
 * label cart items (the order response only carries ids + prices, not names).
 *   GET /api/v1/heru-sales-transaction-engine/pricing/product-lookup
 * Requires the user JWT (FetchV2 attaches it automatically).
 */
export const getProductLookup = async (): Promise<ProductLookupItem[]> => {
	const res = await get<{ products: ProductLookupItem[] }>({
		service: 'salesTransactionEngine',
		endpoint: `/pricing/product-lookup`,
	});
	return res?.products ?? [];
};
